import {findStep} from './utils.js';
import StepBucket from '../StepBucket.js';

export const legato = (group, stepBuckets) => {
    let steps = [...group.steps];

    for (let i=0; i < steps.length - 1; i++) {
        let step = steps[i];
        let nextStep = steps[i+1];
        let currentStepNumber = findStep(stepBuckets, step);
        let nextStepNumber = findStep(stepBuckets, nextStep);
        let stepBucket = stepBuckets[currentStepNumber.stepNumber];
        let _stepBucket = new StepBucket(stepBucket.track);
        for (let position in stepBucket.steps) {
            let stepData = stepBucket.steps[position];
            let copiedStepData = stepData.getCopy();
            let duration = (nextStepNumber.stepNumber - currentStepNumber.stepNumber) / 2.0;
            copiedStepData.duration = duration;
            _stepBucket.steps[position] = copiedStepData;
        }
        stepBuckets[currentStepNumber.stepNumber] = _stepBucket;
    }
    return stepBuckets;
};
